import { locationFactory } from '@rtls/core/models/location/location.factory';
import { ThingHistory } from '@rtls/core/models/thing/thing-history.model';
import { thingSummaryFactory } from '@rtls/core/models/thing/thing-summary.factory';
import { nullable, randomDate, randomPoint } from '@rtls/map/util/factory/factory.util';
import * as Factory from 'factory.ts/lib';

export const thingHistoryFactory = Factory.makeFactory<ThingHistory>({
	id: Factory.each((i) => i),
	position: Factory.each(() => randomPoint()),
	validPosition: true,
	location: Factory.each((i) => nullable(locationFactory.build())),
	realTimeClock: Factory.each(() => randomDate()),
	thing: Factory.each(() => thingSummaryFactory.build()),
	wakeReason: 'START',
});
